// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-page-spinner{background:conic-gradient(from 90deg at 50% 50%,rgba(39,174,96,0) 0deg,#d1b8f2 .04deg,#6002d8 1turn)}.ellipse-dot1{animation:jump-up .6s linear .1s infinite}.ellipse-dot2{animation:jump-up .6s linear .2s infinite}.ellipse-dot3{animation:jump-up .6s linear .3s infinite}@keyframes jump-up{to{opacity:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
